






















































































































metaMixin = require '@/mixins/meta'

export default {
  name: 'home-page',

  mixins: [metaMixin]

  # components:

  data: ->
    activeGradient: 0
    meta:
      title: 'Lucre Games 🤞 An Indie Game Studio'
      description: 'Creating game experiences that balance fun with intrigue and mechanics with art.'
      image: 'https://lucregames.com/static/lucre-games-indie-game-sacramento-social-card.jpg'
      route: '/'

    images:
      fbfLogo: require '@/assets/images/games/fly-by-fire/fly-by-fire-logo-lucre-games.png'
      fbfTony: require '@/assets/images/games/fly-by-fire/fly-by-fire-lucre-games-lowpoly-skeleton-tiki-tony.jpg'
      fbfPoster: require '@/assets/images/games/fly-by-fire/fly-by-fire-lucre-games-lowpoly-landscape-poster.jpg'
      fbfGascan: require '@/assets/images/games/fly-by-fire/fly-by-fire-lucre-games-lowpoly-gas-can-bullets.jpg'

      haosLogo: require '@/assets/images/games/haos/haos-game-lucre-games-logo-black.png'
      haosBanner: require '@/assets/images/games/haos/haos-game-lucre-games-banner.jpg'
      haosGameplay1: require '@/assets/images/games/haos/haos-game-lucre-games-gameplay-1.gif'
      haosGameplay2: require '@/assets/images/games/haos/haos-game-lucre-games-gameplay-2.gif'
      haosGameplay3: require '@/assets/images/games/haos/haos-game-lucre-games-gameplay-3.gif'

      leBanner: require '@/assets/images/games/lost-ethereal/lost-ethereal-lucre-games-pixel-art-banner.jpg'
      leLogo: require '@/assets/images/games/lost-ethereal/lost-ethereal-lucre-games-indie-game-logo.jpg'
      leBridge: require '@/assets/images/games/lost-ethereal/lost-ethereal-pixel-art-low-res-retro-8bit-bridges.gif'
      leWindmill: require '@/assets/images/games/lost-ethereal/lost-ethereal-pixel-art-low-res-retro-8bit-windmill.gif'
      leDesert: require '@/assets/images/games/lost-ethereal/lost-ethereal-pixel-art-low-res-retro-8bit-desert.png'


      geotapScreen1: require '@/assets/images/games/geotap-game/geotap-game-lucre-games-classic-mode-mobile.jpg'
      geotapScreen2: require '@/assets/images/games/geotap-game/geotap-game-lucre-games-tranquil-mode-mobile.jpg'
      geotapScreen3: require '@/assets/images/games/geotap-game/geotap-game-lucre-games-focus-mode-mobile.jpg'
      coin: require '@/assets/images/lucre-games-coin-low-poly-3d-rotating.gif'
      geotapTrailer: require '@/assets/images/games/geotap-game/geotap-game-trailer-screen.jpg'
      geotapShapes: require '@/assets/images/games/geotap-game/geotap-game-mobile-unlockable-low-poly-shapes.jpg'
      stairs: require '@/assets/images/games/geotap-game/geotap-game-stairs-lowpoly-shape.jpg'
      chapel: require '@/assets/images/games/geotap-game/geotap-game-chapel-lowpoly-shape.jpg'
      cone: require '@/assets/images/games/geotap-game/geotap-game-cone-lowpoly-shape.jpg'
}




// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/Home.vue